<template>
  <div class="wrapper-skill">
     <font-awesome-icon v-if="skill.isIcon"  class=" text-4xl  md:text-6xl  "
      :class="'text-'+skill.name" :icon="skill.icon" />

    <img class="md:h-20 h-10" v-else
      :src="require('@/assets/images/skills/' + skill.image)" :alt="skill.name">
  </div>
</template>
<script>
export default {
  name: 'SkillItem',
  props: {
    skill: {
      type: Object,
      required: true,
    },
  },
};
</script>
<style scoped>
</style>
